import { JSX } from "react";

import { Box, CssBaseline, Theme, useTheme } from "@mui/material";
import { isMobile } from "react-device-detect";
import { Outlet } from "react-router-dom";
import MobileSidebar from "src/components/Sidebar/MobileSidebar/MobileSidebar";

import Sidebar from "../components/Sidebar/Sidebar";

const getStyles = (theme: Theme, isMobile: boolean) => ({
  main: {
    flexGrow: 1,
    p: isMobile ? 2 : 3,
    backgroundColor: theme.palette.surface.subtle,
    minHeight: "100vh",
    overflow: "auto",
    ...(isMobile && { marginTop: 9 }),
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
  },
});

function MainLayout(): JSX.Element {
  const theme = useTheme();
  return (
    <Box display='flex'>
      <CssBaseline />
      {!isMobile && <Sidebar />}
      <Box component='main' sx={getStyles(theme, isMobile).main}>
        {isMobile && <MobileSidebar />}
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainLayout;
